import { render, staticRenderFns } from "./AsyncFallback.vue?vue&type=template&id=06ecd06c&scoped=true&"
import script from "./AsyncFallback.vue?vue&type=script&lang=js&"
export * from "./AsyncFallback.vue?vue&type=script&lang=js&"
import style0 from "./AsyncFallback.vue?vue&type=style&index=0&id=06ecd06c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ecd06c",
  null
  
)

export default component.exports